import { memo, useEffect, useState } from "react";
import { Divider, Grid2, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import Accordion from "../components/Accordion.js";
import Spinner from "../components/Spinner.js";
import { useSnackbar } from "../utils/index.js";
import { getSubmissionsAdmin } from "../api/index.js";

const Submissions = () => {
	const { error } = useSnackbar();
	const [submissions, setSubmissions] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const fetchSubmissions = async () => {
		setIsLoading(true);
		const { success: getSuccess, submissions: fetchedSubmissions, message } = await getSubmissionsAdmin();
		if (getSuccess) {
			setSubmissions(fetchedSubmissions);
		} else {
			error(message);
		}

		setIsLoading(false);
	};

	useEffect(() => {
		fetchSubmissions();
	}, []);
	
	return (
		<>
			<Spinner open={isLoading} />
			<Grid2 container display="flex" direction="column" justifyContent="center" alignItems="center">
				{submissions.length === 0 && (
					<Grid2 mt={2}>
						<Typography>{"No submissions found"}</Typography>
					</Grid2>
				)}
				{submissions.map((sbm) => (
					<Grid2 mt={2} width="100%">
						<Accordion
							alwaysExpanded={false}
							title={(
								<Grid2
									container
									width="100%"
									display="flex"
									direction="row"
									alignItems="center"
									justifyContent="flex-start"
								>
									<Typography>{sbm.name}</Typography>
								</Grid2>
							)}
							subtitle={(
								<Grid2 container display="flex" direction="row" alignItems="center" justifyContent="center" spacing={0}>
									<Grid2 size={{ xs: 4 }}>
										<Typography>{"Description"}</Typography>
									</Grid2>
									<Grid2 size={{ xs: 8 }} textAlign="center">
										<Typography>{"Project URL"}</Typography>
									</Grid2>
								</Grid2>
							)}
							content={(
								<Grid2 container width="100%" display="flex" direction="column" alignItems="center" justifyContent="center" spacing={0} color="black">
									{sbm.submissions.map((tmSbm, ind) => (
										<Grid2 key={`comp_${ind}`} flexDirection="column" width="100%">
											{ind !== 0
											&& (
												<Grid2 key={`divider_${ind}`} my={1} width="100%">
													<Divider style={{ width: "100%" }} />
												</Grid2>
											)}
											<Grid2 key={`row_${ind}`} container alignItems="center">
												<Grid2 size={{ xs: 4 }}>
													<Typography>{tmSbm.description}</Typography>
												</Grid2>
												<Grid2 size={{ xs: 8 }} textAlign="center">
													<Link to={tmSbm.url} target="_blank" rel="noreferrer">{tmSbm.url}</Link>
												</Grid2>
											</Grid2>
										</Grid2>
									))}
									{sbm.submissions.length === 0 && (
										<Grid2 mt={2}>
											<Typography>{"No submissions found"}</Typography>
										</Grid2>
									)}
								</Grid2>
							)}
						/>
					</Grid2>
				))}
			</Grid2>
		</>
	);
};

export default memo(Submissions);
